/**
 * Hotel Search Form JS
 * Google Places autocomplete, room config modal, date handling
 */
(function HotelSearchForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'HotelSearch'
	};

	var rooms = [{
		adults   : 2,
		children : 0,
		childAges: []
	}];

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	// ─── Destination autocomplete (same pattern as WebSearchBarForm: Adzuki.Typeahead + URL) ─────

	function initHotelLocationTypeahead($form) {
		var $locationInput = ($form && $form.length) ? $form.find('.hotel-location-autocomplete') : $('.hotel-location-autocomplete');
		var $wrap, $clearBtn;

		function updateClearVisibility() {
			$clearBtn.toggle($locationInput.val().length > 0);
		}

		function doClear() {
			$locationInput.val('');
			$locationInput.closest('form').find('input[name*="[place_id]"]').val('');
			$locationInput.closest('.google-places').find('input.lat').val('');
			$locationInput.closest('.google-places').find('input.lng').val('');
			$clearBtn.hide();
			$locationInput.focus();
		}

		if (!$locationInput.length) {
			return;
		}

		$wrap = $locationInput.closest('.hotel-location-input-wrap');
		$clearBtn = $wrap.length ? $wrap.find('.hotel-location-clear') : $();

		if ($clearBtn.length) {
			$clearBtn.on('click', function clearLocation(e) {
				e.preventDefault();
				doClear();
			});

			$clearBtn.on('keydown', function onClearKeydown(e) {
				if (e.which === 13 || e.which === 32) {
					e.preventDefault();
					doClear();
				}
			});

			$locationInput.on('input change', updateClearVisibility);
			updateClearVisibility();
		}

		Adzuki.Typeahead(
			$locationInput,
			'/Searches/googleAutocomplete/',
			function select(item, $self) {
				var $f = $self.closest('form');

				$self.val(item.name || '');
				$f.find('input[name*="[place_id]"]').val(item.id || '');
				updateClearVisibility();

				// Fetch lat/lng (googleAutocomplete returns id + name only)
				Adzuki.Ajax.post('/Searches/google', {
					type    : 'coordinateData',
					place_id: item.id
				}).then(function onCoords(res) {
					if (res && res.results) {
						$f.find('input.lat').val(res.results.lat || '');
						$f.find('input.lng').val(res.results.lng || '');
					}
				});
			}
		);
	}

	// ─── Room Configuration ─────────────────────────────────────────

	function buildChildAgeSelect(roomIndex, childIndex, selectedAge) {
		var html = '<select class="form-control input-sm hotel-child-age-select" data-room="' + roomIndex + '" data-child="' + childIndex + '">',
			age;

		for (age = 0; age <= 17; age++) {
			html += '<option value="' + age + '"' + (age === selectedAge ? ' selected' : '') + '>';
			html += (age === 0 ? '<1' : String(age));
			html += '</option>';
		}
		html += '</select>';
		return html;
	}

	function buildRoomConfigUI() {
		var $container = $('.hotel-room-config-container'),
			r, room, html, c;

		$container.empty();

		// Number of Rooms stepper at top (matches Room Configuration modal design)
		html = '<div class="hotel-number-of-rooms-row margin10-bot">'
			+ '<div class="row">'
			+ '<div class="col-xs-6"><label>Number of Rooms</label></div>'
			+ '<div class="col-xs-6 text-right">'
			+ '<div class="hotel-stepper">'
			+ '<button type="button" class="btn btn-default btn-xs hotel-num-rooms-minus">-</button>'
			+ '<span class="hotel-stepper-value hotel-num-rooms-value">' + rooms.length + '</span>'
			+ '<button type="button" class="btn btn-default btn-xs hotel-num-rooms-plus">+</button>'
			+ '</div></div></div>';

		$container.append(html);

		for (r = 0; r < rooms.length; r++) {
			room = rooms[r];
			html = '<div class="hotel-room-config-row margin10-top" data-room-index="' + r + '">'
				+ '<div class="hotel-room-label"><strong>Room ' + (r + 1) + '</strong></div>'
				+ '<div class="row margin5-top">'
				+ '<div class="col-xs-6"><label>Adults</label></div>'
				+ '<div class="col-xs-6 text-right">'
				+ '<div class="hotel-stepper">'
				+ '<button type="button" class="btn btn-default btn-xs hotel-stepper-minus" data-field="adults" data-room="' + r + '">-</button>'
				+ '<span class="hotel-stepper-value">' + room.adults + '</span>'
				+ '<button type="button" class="btn btn-default btn-xs hotel-stepper-plus" data-field="adults" data-room="' + r + '">+</button>'
				+ '</div></div></div>'
				+ '<div class="row margin5-top">'
				+ '<div class="col-xs-6"><label>Children</label></div>'
				+ '<div class="col-xs-6 text-right">'
				+ '<div class="hotel-stepper">'
				+ '<button type="button" class="btn btn-default btn-xs hotel-stepper-minus" data-field="children" data-room="' + r + '">-</button>'
				+ '<span class="hotel-stepper-value">' + room.children + '</span>'
				+ '<button type="button" class="btn btn-default btn-xs hotel-stepper-plus" data-field="children" data-room="' + r + '">+</button>'
				+ '</div></div></div>';

			// Child ages (required when children > 0)
			if (room.children > 0) {
				html += '<div class="hotel-child-ages margin5-top">';
				html += '<div class="hotel-child-ages-label"><small>Child Ages</small></div>';
				for (c = 0; c < room.children; c++) {
					html += '<div class="row margin5-top">'
						+ '<div class="col-xs-6"><small>Child ' + (c + 1) + ' Age</small></div>'
						+ '<div class="col-xs-6">'
						+ buildChildAgeSelect(r, c, room.childAges[c] || 0)
						+ '</div></div>';
				}
				html += '</div>';
			}

			html += '</div>';
			$container.append(html);
		}
	}

	function updateDisplayText() {
		var totalRooms    = rooms.length,
			totalAdults   = 0,
			totalChildren = 0,
			text, i;

		for (i = 0; i < rooms.length; i++) {
			totalAdults += rooms[i].adults;
			totalChildren += rooms[i].children;
		}

		text = totalRooms + ' Room' + (totalRooms > 1 ? 's' : '')
			+ ', ' + totalAdults + ' Adult' + (totalAdults > 1 ? 's' : '');

		if (totalChildren > 0) {
			text += ', ' + totalChildren + ' Child' + (totalChildren > 1 ? 'ren' : '');
		}

		$('.hotel-room-display').val(text);
	}

	function serializeRooms() {
		$('input[name*="rooms_json"]').val(JSON.stringify(rooms));
	}

	form.load = function load($form)
	{
		var $roomsInput = $form.find('input[name*="rooms_json"]').add($('input[name*="rooms_json"]'));
		var existingVal = $roomsInput.length ? $roomsInput.first().val() : '';
		var parsed, $modal;

		// Sync rooms from pre-filled form (e.g. on search results page) so "1 Room, 2 Adults" display is correct
		if (existingVal) {
			try {
				parsed = JSON.parse(existingVal);
				if (Array.isArray(parsed) && parsed.length > 0) {
					rooms = parsed.map(function mapRoom(room) {
						var childAges = room.childAges;

						if (!Array.isArray(childAges)) {
							childAges = room.child_ages;
						}
						if (!Array.isArray(childAges)) {
							childAges = [];
						}
						return {
							adults   : parseInt(room.adults, 10) || parseInt(room.num_adults, 10) || 1,
							children : parseInt(room.children, 10) || parseInt(room.num_children, 10) || 0,
							childAges: childAges
						};
					});
				}
			} catch (e) {
				// keep default rooms
			}
		}

		// Attach destination autocomplete (Adzuki.Typeahead, same pattern as WebSearchBarForm tour location)
		initHotelLocationTypeahead($form);

		// Move room config modal to body so it stacks above Bootstrap backdrop (avoids .tab-content z-index stacking context)
		$modal = $('#hotelRoomConfigModal');
		if ($modal.length && !$modal.parent().is('body')) {
			$('body').append($modal);
		}

		// Stepper buttons
		$(document).on('click', '.hotel-stepper-minus, .hotel-stepper-plus', function stepperClick() {
			var field   = $(this).data('field'),
				roomIdx = $(this).data('room'),
				isPlus  = $(this).hasClass('hotel-stepper-plus');

			if (field === 'adults') {
				if (isPlus && rooms[roomIdx].adults < 10) {
					rooms[roomIdx].adults++;
				}
				if (!isPlus && rooms[roomIdx].adults > 1) {
					rooms[roomIdx].adults--;
				}
			} else if (field === 'children') {
				if (isPlus && rooms[roomIdx].children < 10) {
					rooms[roomIdx].children++;
					rooms[roomIdx].childAges.push(0);
				}
				if (!isPlus && rooms[roomIdx].children > 0) {
					rooms[roomIdx].children--;
					rooms[roomIdx].childAges.pop();
				}
			}

			buildRoomConfigUI();
			updateDisplayText();
			serializeRooms();
		});

		// Child age change
		$(document).on('change', '.hotel-child-age-select', function childAgeChange() {
			var roomIdx  = $(this).data('room'),
				childIdx = $(this).data('child');

			rooms[roomIdx].childAges[childIdx] = parseInt($(this).val());
			serializeRooms();
		});

		// Number of Rooms stepper (modal top)
		$(document).on('click', '.hotel-num-rooms-plus', function numRoomsPlus() {
			if (rooms.length < 4) {
				rooms.push({
					adults   : 2,
					children : 0,
					childAges: []
				});
				buildRoomConfigUI();
				updateDisplayText();
				serializeRooms();
			}
		});
		$(document).on('click', '.hotel-num-rooms-minus', function numRoomsMinus() {
			if (rooms.length > 1) {
				rooms.pop();
				buildRoomConfigUI();
				updateDisplayText();
				serializeRooms();
			}
		});

		// When room config modal is shown, build its content (works with data-toggle or programmatic open)
		$('#hotelRoomConfigModal').on('show.bs.modal', function onModalShow() {
			buildRoomConfigUI();
		});

		// Done button in modal
		$(document).on('click', '.hotel-room-config-done', function doneConfig() {
			serializeRooms();
			$('#hotelRoomConfigModal').modal('hide');
		});

		// Init display
		updateDisplayText();
		serializeRooms();

		// ─── Date: set check-out to check-in + 1 when check-in is in the past or check-out is empty/not after check-in ─────

		function getCheckOutField() {
			var $el = $('#hotelsearch-check_out');

			return $el.length ? $el : $('[name="check_out"]');
		}

		function setCheckoutOneDayAfterCheckin(checkInMoment) {
			var $checkOut = getCheckOutField();
			var nextDay  = checkInMoment.clone().add(1, 'days');

			if ($checkOut.length && $checkOut.data('DateTimePicker')) {
				$checkOut.data('DateTimePicker').date(nextDay);
			} else {
				$checkOut.val(nextDay.format('YYYY-MM-DD'));
			}
		}

		// DateTimePicker (dp.change) — same pattern as WebSearchBarForm / ErezHotelSearchForm
		$('#hotelsearch-check_in').add($('[name="check_in"]')).on('dp.change', function onCheckInChange(e) {
			var $checkOut     = getCheckOutField();
			var checkOutVal   = $checkOut.length ? $checkOut.val() : '';
			var checkOutMoment = checkOutVal ? moment(checkOutVal) : null;

			if (!e.date) {
				return;
			}
			if (
				e.date.isBefore(moment(), 'day') ||
				!checkOutVal ||
				!checkOutMoment ||
				!checkOutMoment.isAfter(e.date, 'day')
			) {
				setCheckoutOneDayAfterCheckin(e.date);
			}
		});

		// Fallback when date fields are native (no DateTimePicker)
		$('[name="check_in"]').on('change', function checkInChangeFallback() {
			var checkInVal   = $(this).val();
			var $checkOut    = getCheckOutField();
			var checkInMoment;
			var checkOutMoment;

			if (!checkInVal) {
				return;
			}
			checkInMoment  = moment(checkInVal);
			checkOutMoment = $checkOut.val() ? moment($checkOut.val()) : null;
			if (
				checkInMoment.isBefore(moment(), 'day') ||
				!checkOutMoment ||
				!checkOutMoment.isAfter(checkInMoment, 'day')
			) {
				setCheckoutOneDayAfterCheckin(checkInMoment);
			}
		});
	};

	form.beforeSubmit = function beforeSubmit()
	{
		var lat = $('input[name*="[latitude]"]').val(),
			lng = $('input[name*="[longitude]"]').val();

		serializeRooms();

		// validate that location has coordinates
		if (!lat || !lng) {
			Adzuki.Alert.error('Please select a location from the dropdown suggestions.');
			return false;
		}
	};

	form.success = function success(response)
	{
		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		if (response.data && response.data.redirect) {
			window.location.href = response.data.redirect;
		} else if (response.redirect) {
			window.location.href = response.redirect;
		}

		return true;
	};
}(jQuery, window.Adzuki || {}));
